app.controller('earlychoicesController', function (
  $scope,
  $state,
  objectService
) {
  
  $scope.pluralize = {
    'du_ni': objectService.buyers.length > 1 ? 'ni' : 'du',
    'din_er': objectService.buyers.length > 1 ? 'er' : 'din',
    'dina_era': objectService.buyers.length > 1 ? 'era' : 'dina',
  };
});